import { Stack, Text } from "@chakra-ui/react";

import IconSound from "components/Chakra/Icons/Sound";
import { IMarginProps } from "src/types/types";

export const SuspiciousOffer = ({ ...margins }: IMarginProps) => (
  <Stack
    {...margins}
    color="ud-primary"
    borderWidth="1px"
    borderColor="ud-primary"
    bg="ud-primary-100"
    p="16px"
    borderRadius="6px"
    lineHeight="18px"
    direction="row"
    align="center"
  >
    <IconSound color="inherit" />
    <Text color="inherit" size="medium">
      U tohoto inzerátu <b>buďte obezřetní</b>, jeví se nám jako podvodný.
    </Text>
  </Stack>
);
